/**
 * Catálogo de los códigos del certificado de Renta Pagada (F-22 presentado
 * ante el SII) para AT 2026, Régimen 14D3.
 *
 * CODIGOS_PAGADO es GENERADO: no editar a mano. Sale de cruzar las columnas de
 * la tabla `renta_2026_14d3_pagado` con las descripciones del prompt en
 * src/ai-extractors/f22/2026_14d3.js. Para regenerarlo:
 *
 *     npm run codigos-pagado
 *
 * CODIGOS_DESTACADOS sí se edita a mano: es la decisión de qué códigos merecen
 * ir arriba de todo en la página. El generador lo respeta tal como esté.
 *
 * Propio de ESTE año+régimen (mismo criterio que formulas.js/persistence.js):
 * si el SII cambia o agrega códigos en un año futuro, este archivo no se toca.
 */

export const CODIGOS_PAGADO = [
  { column: 'cod_18', codigo: '18', nombre: 'Base imponible IDPC de empresas Pro Pyme' },
  { column: 'cod_20', codigo: '20', nombre: 'IDPC de empresas acogidas al régimen Pro Pyme' },
  { column: 'cod_36', codigo: '36', nombre: 'PPM y remanente del IEAM' },
  { column: 'cod_39', codigo: '39', nombre: 'Reajuste art.72 LIR, código 305' },
  { column: 'cod_53', codigo: '53', nombre: 'Región (número de región)' },
  { column: 'cod_85', codigo: '85', nombre: 'Saldo a favor' },
  { column: 'cod_87', codigo: '87', nombre: 'Monto devolución solicitada' },
  { column: 'cod_90', codigo: '90', nombre: 'Impuesto adeudado' },
  { column: 'cod_91', codigo: '91', nombre: 'Total a pagar (códigos 90 y 39)' },
  { column: 'cod_104', codigo: '104', nombre: 'Retiros o remesas afectos al IGC o IA' },
  { column: 'cod_116', codigo: '116', nombre: 'Remanente de crédito por IDPC proveniente de códigos 1638 y/o 610' },
  { column: 'cod_155', codigo: '155', nombre: 'Rentas de capitales mobiliarios, mayor valor en enajenación de cuotas fondos' },
  { column: 'cod_158', codigo: '158', nombre: 'Sub Total' },
  { column: 'cod_159', codigo: '159', nombre: 'Incremento por IDPC según arts. 54 N°1 y 62 LIR' },
  { column: 'cod_161', codigo: '161', nombre: 'Rta Art 42 Nro 1' },
  { column: 'cod_170', codigo: '170', nombre: 'Base imponible anual de IUSC o IGC' },
  { column: 'cod_304', codigo: '304', nombre: 'IGC o IUSC, Débito Fiscal y/o Tasa Adicional determinado' },
  { column: 'cod_305', codigo: '305', nombre: 'Resultado Liquidación Anual Impuesto a la Renta' },
  { column: 'cod_315', codigo: '315', nombre: 'Fecha de Presentación de la declaración' },
  { column: 'cod_610', codigo: '610', nombre: 'Crédito al IGC o IUSC por IDPC con derecho a devolución' },
  { column: 'cod_645', codigo: '645', nombre: 'CPT positivo final' },
  { column: 'cod_646', codigo: '646', nombre: 'CPT negativo final' },
  { column: 'cod_749', codigo: '749', nombre: 'Rebajas por Incremento Impuesto de Primera Categoría y/o Impuesto Exterior' },
  { column: 'cod_757', codigo: '757', nombre: 'Remanente código 119 y código 116' },
  { column: 'cod_1025', codigo: '1025', nombre: 'Crédito por Impuesto de Primera Categoría sin obligación de restitución con derecho a devolución' },
  { column: 'cod_1098', codigo: '1098', nombre: 'Sueldos, pensiones y otras rentas similares de fuente nacional' },
  { column: 'cod_1400', codigo: '1400', nombre: 'Ingresos del giro percibidos' },
  { column: 'cod_1409', codigo: '1409', nombre: 'Existencias, insumos y servicios del negocio, pagados' },
  { column: 'cod_1410', codigo: '1410', nombre: 'Total de ingresos anuales' },
  { column: 'cod_1411', codigo: '1411', nombre: 'Remuneraciones pagadas' },
  { column: 'cod_1430', codigo: '1430', nombre: 'Total de egresos anuales' },
  { column: 'cod_1432', codigo: '1432', nombre: 'Incentivo al ahorro según art. 14 letra E) LIR' },
  { column: 'cod_1440', codigo: '1440', nombre: 'Base Imponible afecta a IDPC o pérdida tributaria del ejercicio' },
  { column: 'cod_1445', codigo: '1445', nombre: 'CPT o CPTS positivo inicial' },
  { column: 'cod_1451', codigo: '1451', nombre: 'RAI / Remanente ejercicio anterior o saldo inicial (saldo positivo)' },
  { column: 'cod_1454', codigo: '1454', nombre: 'REX/INR / Remanente ejercicio anterior o saldo inicial (saldo positivo)' },
  { column: 'cod_1459', codigo: '1459', nombre: 'RAI / Reversos y/o disminuciones del ejercicio (propios)' },
  { column: 'cod_1463', codigo: '1463', nombre: 'RAI / Aumentos del ejercicio (propios) y otros aumentos' },
  { column: 'cod_1475', codigo: '1475', nombre: 'RAI / Retiros, dividendos o remesas imputados a los RTRE' },
  { column: 'cod_1479', codigo: '1479', nombre: 'Remesas, retiros o dividendos repartidos en el ejercicio' },
  { column: 'cod_1484', codigo: '1484', nombre: 'RAI / Remanente ejercicio siguiente (saldo positivo o negativo)' },
  { column: 'cod_1487', codigo: '1487', nombre: 'REX/INR / Remanente ejercicio siguiente (saldo positivo o negativo)' },
  { column: 'cod_1493', codigo: '1493', nombre: 'Saldo positivo del registro REX al término del ejercicio, antes de imputaciones' },
  { column: 'cod_1494', codigo: '1494', nombre: 'Capital aportado, histórico' },
  { column: 'cod_1496', codigo: '1496', nombre: 'Registro SAC / Acumulados desde 01.01.2017 / No Sujeto a Restitución / Remanente anterior' },
  { column: 'cod_1500', codigo: '1500', nombre: 'Rentas afectas a IGC o IA (RAI) del ejercicio' },
  { column: 'cod_1513', codigo: '1513', nombre: 'Registro SAC / IDPC e IPE base imponible generada en el ejercicio' },
  { column: 'cod_1540', codigo: '1540', nombre: 'Registro SAC / Asignado a remesas, retiros o dividendos' },
  { column: 'cod_1545', codigo: '1545', nombre: 'CPTS positivo final' },
  { column: 'cod_1564', codigo: '1564', nombre: 'Acumulados desde 01.01.2017 / Remanente ejercicio siguiente (saldo positivo)' },
  { column: 'cod_1588', codigo: '1588', nombre: 'Otros ingresos percibidos o devengados' },
  { column: 'cod_1703', codigo: '1703', nombre: 'CPTS positivo' },
  { column: 'cod_1704', codigo: '1704', nombre: 'Remesas, retiros o dividendos repartidos en el ejercicio, históricos' },
  { column: 'cod_1705', codigo: '1705', nombre: 'Base imponible afecta a IDPC del ejercicio' },
  { column: 'cod_1710', codigo: '1710', nombre: 'Incentivo al ahorro según art. 14 letra E) LIR' },
  { column: 'cod_1720', codigo: '1720', nombre: 'Subtotal' },
  { column: 'cod_1729', codigo: '1729', nombre: 'Base imponible antes de rebaja por incentivo al ahorro' },
  { column: 'cod_1867', codigo: '1867', nombre: 'Rentas de capitales mobiliarios (art. 20 N° 2 LIR)' },
  { column: 'cod_1904', codigo: '1904', nombre: 'PPM arts. 84 letras a), c), e), y h) y 14 D N° 3 letra (k) LIR' },
];

/**
 * Los códigos que resumen el resultado de la declaración. La página del
 * certificado los muestra destacados arriba, antes de la tabla completa.
 */
export const CODIGOS_DESTACADOS = [
  { column: 'cod_91', etiqueta: 'Total a pagar' },
  { column: 'cod_87', etiqueta: 'Devolución solicitada' },
  { column: 'cod_20', etiqueta: 'IDPC Pro Pyme' },
  { column: 'cod_18', etiqueta: 'Base imponible IDPC' },
];
